/**
 *
 * @author Matthew Rawson @ 03/05/2018 16:50
 * @description
 * @notes
 */
import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import {Card} from "@irati/ui/src/Layout"
import padding from "@irati/ui/src/global/padding"
import {QuestionStatsContext} from "@irati/insights/context"

import Table from "../../ui/SimpleTable"

import {LoadingOverlay} from "../../ui/LoadingOverlay"
import {CARD_HEADINGS} from "./QuestionReportingCard"
import {QuestionDataRow} from "./"

const ReportingCard = styled(Card)`
  margin-bottom: ${padding.small}
`

const QuestionReportingCardSingleDriver = ({questions, formatMessage, ...props}) => {
  const idNamespace = id("QuestionReportingCardSingleDriver", props)

  return (
    <QuestionStatsContext.Consumer>
      {({loading}) => {
        return (
          <ReportingCard id={idNamespace}>
            <LoadingOverlay loading={loading}>
              <Table id={id("table", idNamespace)} headings={CARD_HEADINGS(formatMessage)} responsive>
                {questions.map((question) => (
                  <QuestionDataRow id={id(question.id, idNamespace)} key={question.id} question={question} />
                ))}
              </Table>
            </LoadingOverlay>
          </ReportingCard>
        )
      }}
    </QuestionStatsContext.Consumer>
  )
}


QuestionReportingCardSingleDriver.propTypes = {
  formatMessage: PropTypes.func.isRequired,
  questions: PropTypes.array
}
QuestionReportingCardSingleDriver.defaultProps = {
  questions: []
}

export default injectIntl(QuestionReportingCardSingleDriver)
